<template>
  <div>
    <row-info :profile="profile" :care-plan="carePlan" />
    <row-nav-bar
      v-if="false"
      :profile="profile"
      @open-export-modal="handleOpenExportModal"
    />
    <row-plan-action-buttons v-if="false" :profile="profile" />
    <div class="px-3 py-2">
      <b-overlay
        :show="showGeneratePlanOverlay"
        :variant="overlay.variant"
        :spinner-variant="overlay.spinner.variant"
        :spinner-type="overlay.spinner.type"
        :spinner-small="overlay.spinner.isSmall"
        :rounded="overlay.rounded"
      >
        <div>
          <living-care-plan
            :profile="profile"
            :care-plan="carePlan"
            :assessments="assessments"
            :assessments-unanswered="assessmentsUnanswered"
            :doc="currDoc"
            :cp-idx="currIdx"
            :max-cps="maxFilteredCarePlans"
            :account-type="accountType"
            :apps="[]"
            :path="pathDocsCollection"
            :path-root-doc="pathRootDocument"
            v-observe-visibility="visibiltyCheck"
            @page-to="handlePageTo"
            @process-doc="handleProcessDoc"
            @generate-plan="handleGeneratePlan"
          />
        </div>
      </b-overlay>
    </div>
    <export-modal
      :modal-id="exportModalId"
      :export-type-id="selectedExportTypeId"
      :curr-idx="currIdx"
      :outputs="outputsArr"
    />
  </div>
</template>

<script>
import Vue from "vue";
import LivingCarePlan from "./livingCarePlan";
import RowInfo from "./rowInfo";
import RowNavBar from "./rowNavBar";
import RowPlanActionButtons from "./rowPlanActionButtons";
import ExportModal from "./exportModal";
import { mapGetters } from "vuex";
import firebase from "firebase";
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);
export default {
  name: "Care_Plan_Generator",
  components: {
    ExportModal,
    LivingCarePlan,
    RowInfo,
    RowNavBar,
    RowPlanActionButtons
  },
  props: {
    carePlan: {
      type: Object,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {};
      }
    },
    accountType: {
      type: String,
      default: "provider"
    },
    pathDocsCollection: {
      type: String,
      default: () => {
        return null;
      }
    },
    pathRootDocument: {
      type: String,
      default: () => {
        return null;
      }
    }
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
    assessments() {
      return this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.assessments &&
        Array.isArray(this.carePlan.plan.assessments)
        ? this.carePlan.plan.assessments
        : [];
    },
    assessmentsUnanswered() {
      return this.assessments && Array.isArray(this.assessments)
        ? this.assessments.filter(anAssessment => {
            return anAssessment &&
              anAssessment.answers &&
              Array.isArray(anAssessment.answers)
              ? anAssessment.answers.length == 0
              : true;
          })
        : [];
    },
    filteredCarePlanDocs() {
      return this.carePlanDocs && Array.isArray(this.carePlanDocs)
        ? this.carePlanDocs.filter(aCarePlanDoc => {
            return (
              aCarePlanDoc.status &&
              aCarePlanDoc.status.state &&
              aCarePlanDoc.status.state == "COMPLETED"
            );
          })
        : [];
    },
    filteredCarePlanDocsOrdered() {
      let _carePlanDocs = this.filteredCarePlanDocs;
      return _carePlanDocs && Array.isArray(_carePlanDocs)
        ? _carePlanDocs.sort((a, b) => {
            if (
              a._created_at &&
              b._created_at &&
              a._created_at.seconds &&
              b._created_at.seconds
            ) {
              this.momentTest = a._created_at.seconds;
              return a._created_at.seconds - b._created_at.seconds;
            }
            return false;
          })
        : [];
    },
    maxFilteredCarePlans() {
      return this.filteredCarePlanDocsOrdered &&
        Array.isArray(this.filteredCarePlanDocsOrdered) &&
        this.filteredCarePlanDocsOrdered.length
        ? this.filteredCarePlanDocsOrdered.length
        : 0;
    },
    currDoc() {
      return this.filteredCarePlanDocsOrdered &&
        Array.isArray(this.filteredCarePlanDocsOrdered) &&
        this.filteredCarePlanDocsOrdered.length > this.currIdx
        ? this.filteredCarePlanDocsOrdered[this.currIdx]
        : null;
    },
    carePlanImgURL() {
      return this.carePlan && this.carePlan.plan && this.carePlan.plan.imgURL
        ? this.carePlan.plan.imgURL
        : "https://picsum.photos/500/500/?image=59";
    },
    carePlanDescription() {
      return this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.description
        ? this.carePlan.plan.description
        : "";
    },
    carePlanCrewHosts() {
      return this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.crew &&
        Array.isArray(this.carePlan.plan.crew)
        ? this.carePlan.plan.crew
        : [];
    },
    careAreasSelected() {
      //assessment_subjective, assessment_objective,diagnosis, goals, planning, rational, implementation, intervention, evaluation,  nutrition, daily_routine, monitoring, legal, finance, caregiver_policy.
      return ["goals", "planning", "implementation", "routine", "legal"];
      /*return this.carePlan && this.carePlan.plan && this.carePlan.plan.careAreas &&
      Array.isArray(this.carePlan.plan.careAreas)
        ? this.carePlan.plan.careAreas.filter((aCareArea)=>{
          return aCareArea == true;
          })
        : [];*/
    },
    heartBeatName() {
      return this.carePlan && this.carePlan.plan && this.carePlan.plan.heartbeat
        ? this.carePlan.plan.heartbeat.firstname
        : null;
    },
    famName() {
      return this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.fam &&
        this.carePlan.plan.fam.firstname
        ? this.carePlan.plan.fam.firstname
        : null;
    },
    famRelationTo() {
      return this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.fam &&
        this.carePlan.plan.fam.relationTo
        ? this.carePlan.plan.fam.relationTo
        : null;
    },
    dementiaStage() {
      return "Stage 4: Moderate Decline";
    },
    showGeneratePlanOverlay() {
      return this.generating;
    }
  },
  methods: {
    visibiltyCheck(isVisible, entry) {
      debugger;
      if (isVisible && this.pathDocsCollection) {
        this.setUpSnapShot();
        if (Array.isArray(this.assessments) && this.assessments.length == 0) {
          this.setAssessmentQuestion(
            "Explain the situation in detail include what you see and vital information",
            0,
            true,
            0
          );
        }
      } else {
        if (this.unsub) {
          this.unsub();
        }
      }
      //reset
      this.currPayloadId = null;
    },
    setUpSnapShot() {
      if (this.pathDocsCollection) {
        //@ToDoMoveto Store
        const db = firebase.firestore();
        this.collectionRef = db.collection(this.pathDocsCollection);

        this.unsub = this.collectionRef.onSnapshot(snapshot => {
          this.carePlanDocs = [];
          snapshot.docs.forEach(doc => {
            this.carePlanDocs.push({ ...doc.data(), id: doc.id });
          });

          if (!this.isEntry) {
            this.handlePayloadProcessing();
          } else {
            this.currIdx =
              this.filteredCarePlanDocsOrdered &&
              Array.isArray(this.filteredCarePlanDocsOrdered)
                ? this.filteredCarePlanDocsOrdered.length - 1
                : 0;
            this.isEntry = false;
          }
        });
      }
    },
    handlePayloadProcessing() {
      //Handle the processing of a submission
      if (this.currPayloadId) {
        let currentGenPlanDoc = this.carePlanDocs.filter(aPayload => {
          return aPayload.genId == this.currPayloadId;
        });

        if (currentGenPlanDoc && Array.isArray(currentGenPlanDoc)) {
          let thisGenPlanDoc = currentGenPlanDoc[0];
          if (
            thisGenPlanDoc &&
            thisGenPlanDoc.status &&
            thisGenPlanDoc.status.state
          ) {
            if (thisGenPlanDoc.status.state == "PROCESSING") {
              this.generating = true;
            } else if (thisGenPlanDoc.status.state == "COMPLETED") {
              this.generating = false;
              this.currPayloadId = null;
              debugger;
              if (thisGenPlanDoc.output && thisGenPlanDoc.id) {
                if (
                  this.processOutput(thisGenPlanDoc.output, thisGenPlanDoc.id)
                ) {
                  //Move to last position- using the filtered
                  this.currIdx =
                    this.filteredCarePlanDocsOrdered &&
                    Array.isArray(this.filteredCarePlanDocsOrdered)
                      ? this.filteredCarePlanDocsOrdered.length - 1
                      : 0;
                }
              }
            } else if (thisGenPlanDoc.status.state == "ERRORED") {
              this.generating = false;
            }
          }
        }
      }
    },
    handleGeneratePlan() {
      this.generatePlan();
    },
    generatePlan() {
      let profileBy = this.profileBy();

      let assessmentInfo =
        this.carePlan && this.carePlan.plan
          ? this.getAssessmentInfo(this.carePlan.plan.assessments)
          : "";
      this.currPayloadId = `gen_${Date.now()}`;

      //Array of Vitals
      //Weight
      //Selected array of options
      //Verify that questions are answered
      //Pause all Tabs
      //hide message Box with Iona
      //Pull from Health Data on the phone
      //this.simpleValidate();

      let assessmentPayload = {
        genId: this.currPayloadId,
        _created_at: new Date(),
        _created_by: profileBy,
        heartbeat: this.heartBeatName ? this.heartBeatName : "HeartBeat",
        fam: this.famName ? this.famName : "family",
        relation: this.famRelationTo,
        dementiaStage: this.dementiaStage ? this.dementiaStage : "No Stage",
        careAreas:
          this.careAreasSelected && Array.isArray(this.careAreasSelected)
            ? this.careAreasSelected.join(",")
            : "",
        assessmentInfo: assessmentInfo
      };
      this.collectionRef.add(assessmentPayload); // Include values for { unspecified parameter } fields
      this.generating = true;
    },
    handleGeneratePlanOverlay(shallOpen) {
      this.showGeneratePlanOverlay = shallOpen;
    },
    carePlanCrewHostNames() {
      if (this.carePlanCrewHosts.length > 0) {
        if (this.carePlanCrewHosts.length === 1)
          return this.carePlanCrewHosts && this.carePlanCrewHosts[0]
            ? this.carePlanCrewHosts[0].name
            : "";
      }
      return "";
    },
    handleInputAnswer(answKV) {
      this.formPrompt[answKV.key] = answKV.value;
    },
    handleOpenExportModal(exportTypeId) {
      this.selectedExportTypeId = exportTypeId;
      this.outputsArr = this.createArrayOfOutputs();
      this.$bvModal.show(this.exportModalId);
    },
    createArrayOfOutputs() {
      let outputsArr = [];
      this.filteredCarePlanDocsOrdered.forEach(aCarePlanDoc => {
        outputsArr.push(this.convertOutputToJSON(aCarePlanDoc.output));
      });
      return outputsArr;
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
          ? `${this.profile.firstname} ${this.profile.lastname}`
          : null,
        imgURL: this.profile ? this.profile.imgURL : null
      };
    },
    handlePageTo(pageNumber) {
      this.currIdx = pageNumber;
    },
    handleProcessDoc() {
      if (this.currDoc && this.currDoc.output && this.currDoc.genId) {
        this.processOutput(this.currDoc.output, this.currDoc.id);
      }
    },
    processOutput(docOutput, docId = 0) {
      if (docOutput) {
        let output = this.convertOutputToJSON(docOutput);

        if (typeof output == "object") {
          //save object on generation
          if (
            output.questions &&
            Array.isArray(output.questions) &&
            output.questions.length > 0
          ) {
            this.processAssessmentQuestionsFromResponseOutputQuestions(
              output.questions,
              docId
            );
            delete output.questions;
          }
          let genPlan = this.processGeneratedPlan(output);
          if (genPlan) {
            this.saveGeneratedPlan(genPlan, docId);
          }
        }
        return true;
      }
      return false;
    },
    convertOutputToJSON(responseOutput, deep = 0) {
      let output = {};
      if (responseOutput) {
        try {
          output = responseOutput.replace(/(\r\n|\n|\r)/gm, "");
          output = JSON.parse(output);
        } catch (e) {
          console.error(e); // error in the above string (in this case, yes)!
          //check if quotes is the issue try again
          if (deep == 0) {
            deep++;
            //const regex = /((?:\s*?{\s*?|\s*?,\s*?)[^:]+)(?=:)/g;
            //const newRespOutput = responseOutput.replace(regex, '"$1"');
            const newRespOutput = responseOutput.replace(
              /(\s*?{\s*?|\s*?,\s*?)(['"])?([a-zA-Z0-9]+)(['"])?:/g,
              '$1"$3":'
            );
            output = this.convertOutputToJSON(newRespOutput, deep);
          }
        }
      }
      return output;
    },
    setAssessmentQuestion(question, genId, updateCarePlan, idx = 0) {
      let createdBy = this.profileBy();

      if (Array.isArray(this.assessments)) {
        this.assessments.push(
          this.createAssessmentObject(question, genId, idx)
        );

        if (updateCarePlan) {
          this.$store
            .dispatch("provider/updateCarePlanAssessments", {
              path: this.pathRootDocument,
              plan: this.carePlan,
              version: 1,
              assessments: this.assessments,
              updatedBy: createdBy
            })
            .then(() => {})
            .catch(err => {});
        }
      }
    },
    createAssessmentObject(question, genId, idx) {
      let createdBy = this.profileBy();
      let theQuestion = question.question ? question.question : question;
      let theExamples =
        question.examples && Array.isArray(question.examples)
          ? question.examples
          : question.examples
          ? [question.examples]
          : [];
      return {
        id: `${theQuestion
          .replace(/ /g, "")
          .substring(0, 4)
          .toLowerCase()}-${Date.now()}-${idx}`,
        _created_at: new Date(),
        _created_by: createdBy,
        genId: genId,
        question: theQuestion,
        examples: theExamples,
        answers: []
      };
    },
    processAssessmentQuestionsFromResponseOutputQuestions(
      responseOutputQuestions,
      genId
    ) {
      if (responseOutputQuestions && Array.isArray(responseOutputQuestions)) {
        let length = responseOutputQuestions.length;
        let idx = 0;
        responseOutputQuestions.forEach(aQuestion => {
          if (aQuestion) {
            this.setAssessmentQuestion(
              aQuestion,
              genId,
              idx == length - 1,
              idx
            );
          }

          idx++;
        });
      }
    },
    getAssessmentInfo(assessments) {
      //@Todo- make a mixin
      let assessmentInfo = "";
      if (assessments && Array.isArray(assessments)) {
        assessments.forEach(anAssessment => {
          //@TODOSort the Answers from earliest to
          if (
            anAssessment.question &&
            anAssessment.answers &&
            Array.isArray(anAssessment.answers) &&
            anAssessment.answers[0] &&
            anAssessment.answers[0].text
          ) {
            assessmentInfo += `\n\nQuestion: ${anAssessment.question} \n`;
            assessmentInfo += `Answer: ${anAssessment.answers[0].text}`;
          }
        });
      }
      return assessmentInfo;
    },
    processGeneratedPlan(outputObj) {
      let plan = {};
      plan._created_at = new Date();

      Object.keys(outputObj).forEach(key => {
        let areaArr = outputObj[key];
        let area = [];
        if (areaArr && Array.isArray(areaArr) && areaArr.length > 0) {
          let idx = 0;
          areaArr.forEach(anAreaText => {
            let item = {
              texts: [],
              ord: idx
            };
            item.texts.push({ text: anAreaText, _created_at: new Date() });
            area.push(item);
          });
          plan[key] = area;
        }
      });
      return plan;
    },
    saveGeneratedPlan(genPlan, docId) {
      let createdBy = this.profileBy();
      this.$store
        .dispatch("provider/addGenPlan", {
          path: `${this.pathDocsCollection}/${docId}`,
          genPlan: genPlan,
          updatedBy: createdBy
        })
        .then(() => {})
        .catch(err => {});
    }
  },
  watch: {
    pathDocsCollection(newValue, oldValue) {
      //temp- may take out
      if (newValue) {
        this.setUpSnapShot();
      }
    }
  },
  data() {
    return {
      isEntry: true,
      carePlanDocs: [],
      currPayloadId: null,
      formErrors: [],
      overlay: {
        variant: "light",
        opacity: 0.95,
        blur: "1rem",
        noWrap: false,
        noCenter: true,
        spinner: {
          variant: "primary",
          type: "grow",
          isSmall: false
        },
        rounded: "sm"
      },
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 150,
        height: 150,
        class: "m1"
      },
      currIdx: 0,
      exportModalId: `export-modal-id-${
        this.carePlan && this.carePlan.id ? this.carePlan.id : "0"
      }`,
      selectedExportTypeId: null, //email|pdf|printer
      outputsArr: [],
      collectionRef: null,
      generating: false
    };
  }
};
</script>

<style lang="scss" scoped>
.header__close {
  position: relative;
  padding-bottom: 8px;
  &.border-none::after {
    content: none !important;
  }
  .ico {
    position: absolute;
    top: 5px;
    right: 13px;
    cursor: pointer;
  }
  .ico__search {
    right: unset !important;
    left: 13px;
  }
  h3 {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 49px;
    text-align: center;

    color: #5b606c;
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    width: 100%;
    border-bottom: 1px solid #e4e6eb;
  }
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
